import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';

export default function NavItem({ to, icon, text }) {
  // Dinamikusan betöltjük az ikont a neve alapján
  const Icon = Icons[icon];

  return (
    <Link 
      to={to} 
      className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md flex items-center space-x-2"
    >
      <span className="inline-flex items-center justify-center mr-3">
        {Icon && <Icon size={20} />}
      </span>
      {text}
    </Link>
  );
} 